import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import tools from '../config';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: {
            id: 0,
            login: "",
            group_id: 0,
        },
        authenticated: false,
        permissions: {},
        token: "",
        editMode: false,

        currentQuestions:[],

        currentResponseId:0
    },
    getters: {
        getToken(state) {

            if (state.token) {
                return state.token;
            }

            let token = Vue.$cookies.get("token");
            if (token) {
                state.token = token;
            }

            return state.token;
        },
        getUser(state) {
            return state.user;
        },
        isAuthenticated(state) {
            return state.authenticated;
        },
        hasPerm: (state) => (hash: string) => {
            return state.permissions[hash];
        },
        onEdit: (state) => {
            return state.editMode;
        },
        getCurrentQuestions: (state) => {
            return state.currentQuestions;
        },
        getCurrentResponseId : (state) => {
            return state.currentResponseId
        }
    },
    mutations: {
        loginSuccess(state, data) {
            state.token = data.token;
            state.user = data.user;
            state.permissions = data.permissions;
            state.authenticated = true;

            Vue.$cookies.set("token", state.token);
            Vue.$cookies.set("userId", state.user.id);

            console.log(state.token);
        },
        deconnect(state) {
            state.token = "";
            Vue.$cookies.remove("token");
            tools.resetLocals();
            
            state.user = {
                id: 0,
                login: "",
                group_id: 0
            };
            state.permissions = {};
            state.authenticated = false;
        },
        onEditMode(state, active) {
            state.editMode = active;
        },
        updateQuestions(state, questions) {
            state.currentQuestions = questions;
        },
        setResponseId(state, responseId) {
            state.currentResponseId = responseId;
        }
    },
    actions: {

        refreshToken(context) {

            return new Promise((resolve, reject) => {

                context.state.authenticated = false;

                let token = Vue.$cookies.get("token");
                let userId = Vue.$cookies.get("userId");

                try {
                    let data = JSON.parse(atob(token.split(".")[1]));

                    let exp = data.exp;

                    if (userId !== data.userId) {
                        return reject();
                    }
                    let date = Math.floor(Date.now() / 1000);

                    if (exp < date) {
                        return reject();
                    }

                    axios.get(tools.api("user/token"),{
                        headers : {
                            'Authorization': "Bearer "+context.getters.getToken,
                        }
                    })
                        .then((response) => {
                            console.log("user/token OK")
                            if (!response.data.id) {
                                return reject();
                            }

                            console.log("commit ok")
                            context.commit("loginSuccess", {
                                user: response.data,
                                token: response.data.token,
                                permissions: response.data.permissions
                            })

                            resolve();
                        })
                        .catch((e) => {
                            reject();
                        })

                    return true;

                } catch (e) {
                    return reject();
                }

                return reject();

            })

        }

    },
    modules: {}
})
